<template>
    <div class="">
        <div class="rootdiv">

            <topmenu></topmenu>


            <div class="container theme-showcase">

                <div>
                    <div style="margin: 15px 0;">
                        <el-page-header @back="goBack" title="Back">
                        </el-page-header>
                    </div>

                </div>

                <div style="padding: 0 15px 15px 15px; border:  1px solid #ccc; margin-bottom: 26px; border-radius: 6px;">

                    <div style="display:flex;">

                        <div style="flex:1;">
                            <div class="mylabel">Name:</div>
                            <div>
                                <el-input v-model="name" placeholder="badge name"></el-input>
                            </div>
                        </div>

                        <div style="flex:1; margin-left:20px;">
                            <!-- <div class="mylabel">Visitor Category:</div>
                            <div>
                                <el-select v-model="visitorCateId" placeholder="Select" clearable>
                                    <el-option v-for="item in catelist" :key="item.id" :label="item.name" :value="item.id">
                                    </el-option>
                                </el-select>
                            </div> -->
                        </div>

                    </div>



                    <div class="mylabel">Content:</div>
                    <div style="border: 1px solid #ccc; background-color:#f1f1f1; padding:10px;">
                        <div>
                            <div class="badgeCanvas" :style="'width:' + width + 'px;' + 'height:' + height + 'px;'">

                                <vue-drag-resize-rotate :parent="true" :prevent-deactivation="true" :rotatable="true"
                                    @rotatestop="onRotateStop" @activated="onActivated(index)" :active.sync="item.active"
                                    @resizestop="onResizeStop" @dragstop="onDragStop" v-for="(item, index) in bfdlist"
                                    :key="index" :x="item.bfdX" :y="item.bfdY" :w="item.bfdWidth" :h="item.bfdHeight"
                                    :r="item.bfdAngle">
                                    <div>
                                        <div v-if="item.bfdType == 1" class="drrDiv"
                                            :style="item.bfdAlignment == '2' ? 'text-align:center;' : item.bfdAlignment == '3' ? 'text-align:right;' : ''"
                                            style="overflow: hidden;">
                                            <span :style="'font-size:' + item.bfdFontSize + 'px;'">
                                                <span :style="'color:' + item.bfdColor + ';'">
                                                    {{ item.name }}
                                                </span>
                                            </span>
                                        </div>
                                        <div v-if="item.bfdType == 2" style="width: 100%; "
                                            :style="'height:' + item.bfdHeight + 'px;'">
                                            <img style="width: 100%; height:100%;" src="../../assets/imgs/qrcode.png" />
                                        </div>
                                        <div v-if="item.bfdType == 3" style="width: 100%; "
                                            :style="'height:' + item.bfdHeight + 'px;'">
                                            <img style="width: 100%; height:100%;" src="../../assets/imgs/barcode.png" />
                                        </div>
                                    </div>
                                </vue-drag-resize-rotate>

                            </div>
                        </div>
                    </div>

                    <div>

                        <div style="display:flex; margin:6px 0; line-height:40px;">
                            <div style=" margin-right:6px;">
                                Width:
                            </div>
                            <div>
                                <el-input-number v-model="width" :min="100"></el-input-number>
                            </div>

                            <div style="margin-left:100px; margin-right:6px;">Height:</div>
                            <div>
                                <el-input-number v-model="height" :min="100"></el-input-number>
                            </div>
                        </div>

                        <div class="mylabel" style="font-weight: bold;">Badge Fields: </div>
                        <div style=" display:flex;">
                            <div
                                style="width:380px; line-height: 34px;  border:1px #f1f1f1 solid; padding:12px; margin-right:16px;">
                                <div class="bfditem" v-for="(item, index) in bfdlist" :key="index"
                                    :class="item.active ? 'bfditemActive' : ''" @click="bfdItemClick(index)">
                                    <div class="bfditemText">{{ item.name }}</div>
                                    <div><el-button icon="el-icon-delete" circle size="mini"
                                            @click.stop="delBfditem(index)"></el-button></div>
                                </div>
                                <div style="text-align:center;">
                                    <el-button type="success" round icon="el-icon-plus" size="small"
                                        @click="bfdAdd">Add</el-button>
                                </div>
                            </div>
                            <div
                                style="flex:1; background-color: #f1f1f1; padding: 12px; line-height:40px; min-height:260px;">
                                <div v-if="bfdEditing">
                                    <div class="bfdItemDiv">
                                        <div class="bfdItemLabel">Type:</div>
                                        <div>
                                            <el-radio-group v-model="bfdType" @input="bfdTypeChange">
                                                <el-radio label="1">Text</el-radio>
                                                <el-radio label="2">Qrcode</el-radio>
                                                <el-radio label="3">Barcode</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </div>

                                    <div class="bfdItemDiv" v-if="bfdType == 1">
                                        <div class="bfdItemLabel">Text:</div>
                                        <div style="flex:1;">
                                            <el-input v-model="bfdText" placeholder="" size="small"
                                                @input="bfdTextChange"></el-input>
                                        </div>
                                    </div>

                                    <div class="bfdItemDiv" v-if="bfdType == 1">
                                        <div class="bfdItemLabel">Fields:</div>
                                        <div style="flex:1;">
                                            <div v-for="item in fieldlist" :key="item.id"
                                                style="display: inline-block; margin:0 6px 0px 0; ">
                                                <el-button @click="insetFd(item.FieldName)" size="mini" plain
                                                    :type="bfdText.indexOf(item.FieldName) >= 0 ? 'success' : ''">{{
                                                        item.FieldName
                                                    }}</el-button>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="bfdItemDiv">
                                        <div class="bfdItemLabel">Width:</div>
                                        <div style="flex:1;">
                                            <el-input-number v-model="bfdWidth" size="small"
                                                @input="bfdWidthChange"></el-input-number>
                                        </div>
                                    </div>

                                    <div class="bfdItemDiv">
                                        <div class="bfdItemLabel">Height:</div>
                                        <div style="flex:1;">
                                            <el-input-number v-model="bfdHeight" size="small"
                                                @input="bfdHeightChange"></el-input-number>
                                        </div>
                                    </div>

                                    <div class="bfdItemDiv">
                                        <div class="bfdItemLabel">X:</div>
                                        <div style="flex:1;">
                                            <el-input-number v-model="bfdX" size="small"
                                                @input="bfdXChange"></el-input-number>
                                        </div>
                                    </div>

                                    <div class="bfdItemDiv">
                                        <div class="bfdItemLabel">Y:</div>
                                        <div style="flex:1;">
                                            <el-input-number v-model="bfdY" size="small"
                                                @input="bfdYChange"></el-input-number>
                                        </div>
                                    </div>

                                    <div class="bfdItemDiv">
                                        <div class="bfdItemLabel">Rotating:</div>
                                        <div style="flex:1;">
                                            <el-input-number v-model="bfdAngle" size="small"
                                                @input="bfdRotatingChange"></el-input-number>
                                        </div>
                                    </div>

                                    <div class="bfdItemDiv" v-if="bfdType == 1">
                                        <div class="bfdItemLabel">Alignment:</div>
                                        <div style="flex:1;">
                                            <el-radio-group v-model="bfdAlignment" @input="bfdAlignmentChange">
                                                <el-radio label="1">Left</el-radio>
                                                <el-radio label="2">Center</el-radio>
                                                <el-radio label="3">Right</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </div>

                                    <div class="bfdItemDiv" v-if="bfdType == 1">
                                        <div class="bfdItemLabel">FontSize:</div>
                                        <div style="flex:1;">
                                            <el-input-number v-model="bfdFontSize" size="small"
                                                @input="bfdFontSizeChange"></el-input-number>
                                        </div>
                                    </div>

                                    <div class="bfdItemDiv" v-if="bfdType == 1">
                                        <div class="bfdItemLabel">Color:</div>
                                        <div style="flex:1;">
                                            <el-color-picker v-model="bfdColor" @change="bfdColorChange"></el-color-picker>
                                        </div>
                                    </div>

                                    <!-- <div style="text-align: center; margin: 1px 0; padding-bottom: 1px;">
                                    <el-button type="success" size="mini"  @click="bfdSubmit">Save</el-button>
                                </div> -->


                                </div>
                            </div>
                        </div>
                    </div>

                    <div style="text-align: center; margin: 20px 0; padding-bottom: 5px;">
                        <el-button type="primary" @click="submit">Save</el-button>
                    </div>
                </div>
                <div style="height: 35px;"> </div>
            </div>

        </div>
    </div>
</template>

<script>
import axios from 'axios'
import topmenu from '../home/components/topmenu'
import VueDragResizeRotate from "@gausszhou/vue-drag-resize-rotate";

export default {
    components: {
        topmenu: topmenu,
        VueDragResizeRotate
    },
    data() {
        return {
            id: 0,
            subject: '',
            EmailTemplateType: 1,
            visitorCateId: '',
            fieldId: '',
            fieldlist: [],
            catelist: [],
            name: '',
            width: 900,
            height: 300,
            bfdType: '1',
            bfdText: '',
            bfdWidth: 100,
            bfdHeight: 40,
            bfdX: 0,
            bfdAngle: 0,
            bfdY: 0,
            bfdAlignment: '1',
            bfdFontSize: 14,
            bfdColor: '#000000',
            bfdlist: [],
            bfdEditing: false,
            activeIndex: 0,
        }
    },
    methods: {
        bfdColorChange(res) {

            var bfdlist = this.bfdlist;
            var item = bfdlist[this.activeIndex];
            item.bfdColor = res;

            bfdlist.splice(this.activeIndex, 1, item);
            this.bfdlist = bfdlist;
        },
        bfdFontSizeChange(res) {

            var bfdlist = this.bfdlist;
            var item = bfdlist[this.activeIndex];
            item.bfdFontSize = res;

            bfdlist.splice(this.activeIndex, 1, item);
            this.bfdlist = bfdlist;
        },
        bfdAlignmentChange(res) {

            var bfdlist = this.bfdlist;
            var item = bfdlist[this.activeIndex];
            item.bfdAlignment = res;

            bfdlist.splice(this.activeIndex, 1, item);
            this.bfdlist = bfdlist;
        },
        bfdYChange(res) {

            var bfdlist = this.bfdlist;
            var item = bfdlist[this.activeIndex];
            item.bfdY = res;

            bfdlist.splice(this.activeIndex, 1, item);
            this.bfdlist = bfdlist;
        },

        bfdRotatingChange(res) {
            console.log(res);
            var bfdlist = this.bfdlist;
            var item = bfdlist[this.activeIndex];
            item.bfdAngle = res;

            bfdlist.splice(this.activeIndex, 1, item);
            this.bfdlist = bfdlist;
        },

        bfdXChange(res) {

            var bfdlist = this.bfdlist;
            var item = bfdlist[this.activeIndex];
            item.bfdX = res;

            bfdlist.splice(this.activeIndex, 1, item);
            this.bfdlist = bfdlist;
        },
        bfdHeightChange(res) {

            var bfdlist = this.bfdlist;
            var item = bfdlist[this.activeIndex];
            item.bfdHeight = res;

            bfdlist.splice(this.activeIndex, 1, item);
            this.bfdlist = bfdlist;
        },
        bfdWidthChange(res) {

            var bfdlist = this.bfdlist;
            var item = bfdlist[this.activeIndex];
            item.bfdWidth = res;

            bfdlist.splice(this.activeIndex, 1, item);
            this.bfdlist = bfdlist;
        },
        bfdTextChange(res) {

            var bfdlist = this.bfdlist;
            var item = bfdlist[this.activeIndex];
            item.bfdText = res;

            var name = this.bfdText;
            if (this.bfdType == 2) {
                name = ' Qrcode';
            } else if (this.bfdType == 3) {
                name = ' Barcode';
            }
            item.name = name;

            bfdlist.splice(this.activeIndex, 1, item);
            this.bfdlist = bfdlist;
        },
        bfdTypeChange(res) {
            var bfdlist = this.bfdlist;
            var item = bfdlist[this.activeIndex];
            item.bfdType = res;

            var name = this.bfdText;
            if (this.bfdType == 2) {
                name = ' Qrcode';
            } else if (this.bfdType == 3) {
                name = ' Barcode';
            }
            item.name = name;

            bfdlist.splice(this.activeIndex, 1, item);
            this.bfdlist = bfdlist;
        },
        onActivated(index) {
            this.activeIndex = index;
            console.log(index);
            var bfdlist = this.bfdlist;
            for (var i = 0; i < bfdlist.length; i++) {
                if (i == index) {
                    bfdlist[i].active = true;
                } else {
                    bfdlist[i].active = false;
                }
            }
            this.bfdlist = bfdlist;
            this.changeEditForm(index);
        },
        onRotateStop(x) {

            var bfdlist = this.bfdlist;
            var item = bfdlist[this.activeIndex];
            item.bfdAngle = x;

            bfdlist.splice(this.activeIndex, 1, item);
            this.bfdlist = bfdlist;
            this.bfdAngle = x;
        },
        onResizeStop(x, y, width, height) {
            console.log(x, y, width, height);
            console.log(this.activeIndex);

            var bfdlist = this.bfdlist;
            var item = bfdlist[this.activeIndex];
            item.bfdWidth = width;
            item.bfdHeight = height;


            bfdlist.splice(this.activeIndex, 1, item);
            this.bfdlist = bfdlist;
            this.bfdWidth = width;
            this.bfdHeight = height;

        },
        onDragStop(x, y) {
            console.log(x, y);
            var bfdlist = this.bfdlist;
            var item = bfdlist[this.activeIndex];
            item.bfdX = x;
            item.bfdY = y;

            bfdlist.splice(this.activeIndex, 1, item);
            this.bfdlist = bfdlist;
            this.bfdX = x;
            this.bfdY = y;
        },
        bfdAdd() {
            this.bfdEditing = true;
            this.bfdType = '1';
            this.bfdAlignment = '1';
            this.bfdText = '';
            this.bfdWidth = 120;
            this.bfdHeight = 120;
            this.bfdAngle = 0;
            this.bfdX = 0;
            this.bfdY = 0;
            this.bfdFontSize = 14;
            this.bfdColor = '#000000';

            var bfdlist = this.bfdlist;
            var name = this.bfdText;
            if (this.bfdType == 2) {
                name = ' Qrcode';
            } else if (this.bfdType == 3) {
                name = ' Barcode';
            }
            var item = { name: name, active: true, bfdType: this.bfdType, bfdText: this.bfdText, bfdWidth: this.bfdWidth, bfdHeight: this.bfdHeight, bfdX: this.bfdX, bfdY: this.bfdY, bfdAngle: this.bfdAngle, bfdAlignment: this.bfdAlignment, bfdFontSize: this.bfdFontSize, bfdColor: this.bfdColor };
            bfdlist.push(item);
            this.bfdlist = bfdlist;
            this.activeIndex = bfdlist.length - 1;
            this.bfdItemClick(this.activeIndex);
        },
        bfdSubmit() {
            // this.bfdEditing=false;
            var bfdlist = this.bfdlist;
            var name = this.bfdText;
            if (this.bfdType == 2) {
                name = ' Qrcode';
            } else if (this.bfdType == 3) {
                name = ' Barcode';
            }
            var item = { name: name, active: true, bfdType: this.bfdType, bfdText: this.bfdText, bfdWidth: this.bfdWidth, bfdHeight: this.bfdHeight, bfdX: this.bfdX, bfdY: this.bfdY, bfdAlignment: this.bfdAlignment, bfdFontSize: this.bfdFontSize, bfdColor: this.bfdColor };
            bfdlist.push(item);
            this.bfdlist = bfdlist;
        },
        changeEditForm(index) {
            this.bfdEditing=true;
            console.log(index);
            var bfdlist = this.bfdlist;
            var item = bfdlist[index];
            this.bfdType = item.bfdType;
            this.bfdAlignment = item.bfdAlignment;
            this.bfdText = item.bfdText;
            this.bfdWidth = item.bfdWidth;
            this.bfdHeight = item.bfdHeight;
            this.bfdAngle = item.bfdAngle;
            this.bfdX = item.bfdX;
            this.bfdY = item.bfdY;
            this.bfdFontSize = item.bfdFontSize;
            this.bfdColor = item.bfdColor;
        },
        bfdItemClick(index) {

            this.activeIndex = index;
            var bfdlist = this.bfdlist;
            for (var i = 0; i < bfdlist.length; i++) {
                if (i == index) {
                    bfdlist[i].active = true;
                } else {
                    bfdlist[i].active = false;
                }
            }
            this.bfdlist = bfdlist;
            this.changeEditForm(index);
        },
        delBfditem(index) {
            var bfdlist = this.bfdlist;
                console.log(index);
            if(index == 0){
                bfdlist.splice(index, 1);
                this.bfdEditing=false;
            }else{
                var item = bfdlist[index];
                console.log(item);
                var pitem = bfdlist[index-1];
                if(item.active){
                    pitem.active=true;
                }
                bfdlist.splice(index-1, 1,pitem);
                bfdlist.splice(index, 1);
            }
            this.bfdlist = bfdlist;
        },
        onSubmit() {
            this.loading = true;
            this.btnDis = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));

            var uid = userJson.uid;
            var token = userJson.token;
            axios.post('/api/Badge/edit',
                {
                    uid: uid,
                    token: token,
                    id: this.id,
                    eventId: this.eventId,
                    name: this.name,
                    visitorCateId: this.visitorCateId,
                    bfdlist:this.bfdlist,
                    width: this.width,
                    height: this.height
                }
            )
                .then(this.submitSucc)
        },
        submitSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.$message({
                    message: 'Success!',
                    type: 'success',
                    onClose: () => {
                    }
                });
                this.$router.back();
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },
        submit() {
            if (this.name == '' || this.name == undefined) {
                this.$message.error('Please enter Name');
                return;
            }
            this.onSubmit();
        },
        goBack() {
            this.$router.back();
        },

        insetFd(fd) {
            var bfdText = this.bfdText;
            if (bfdText.indexOf('{{' + fd + '}}') >= 0) {
                bfdText = bfdText.replace('{{' + fd + '}}', '');
            } else {
                bfdText = bfdText + '{{' + fd + '}}';
            }
            this.bfdText = bfdText;
            this.bfdTextChange(bfdText);
        },

        loadCate() {
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/Visitor/getCateList',
                {
                    eventId: this.eventId,
                    skip: 0,
                    limit: 1000,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.loadCateSucc)
        },
        loadCateSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.catelist = res.list;
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },
        loadData() {
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/Badge/getList',
                {
                    eventId: this.eventId,
                    id: this.id,
                    limit: 1,
                    skip: 0,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.loadDataSucc)
        },
        loadDataSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                var list = res.list;
                if (list && list.length > 0) {
                    var item = list[0];
                    this.name = item.name;
                    this.width = item.width;
                    this.height = item.height;
                    this.bfdlist = item.bfdlist;
                    if(this.bfdlist.length>0){
                        // this.bfdEditing=true;
                    }
                }
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },

        loadFields() {
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/Fields/getFieldsList',
                {
                    eventId: this.eventId,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.loadFieldsSucc)
        },
        loadFieldsSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.fieldlist = res.list;
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },

        onCreated(editor) {
            this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
        },
    },
    mounted() {
        const id = this.$route.query.id;
        const eid = this.$route.query.eid;
        console.log(id)
        if (eid != undefined && eid != '') {
            this.eventId = eid;
        }
        if (id != undefined && id != '') {
            this.id = id;
            this.loadData();
        }
        // this.loadCate();
        this.loadFields();
    },
    beforeDestroy() {

    }
}
</script>

<style scoped>
.mylabel {
    line-height: 35px;
    font-size: 16px;
    margin-top: 5px;
}

.rootdiv>>>.topmenuitem:nth-child(8) {
    color: #fff;
    background-color: #080808;
}

.badgeCanvas {
    background: #fff;
}

.bfditem {
    border: 1px #f1f1f1 solid;
    padding: 0 6px;
    display: flex;
    margin-bottom: 10px;
}

.bfditemText {
    flex: 1;
    overflow: hidden;
    margin-right: 8px;
}

.bfditemActive {
    border: 1px #409EFF solid;
}

.bfdItemDiv {
    display: flex;
    margin-bottom: 5px;
}

.bfdItemLabel {
    margin-right: 10px;
    width: 80px;
    text-align: right;
}</style>


// WEBPACK FOOTER //
// src/pages/badgelist/addbadge.vue